var render, staticRenderFns
import script from "./el-table2.vue?vue&type=script&lang=js"
export * from "./el-table2.vue?vue&type=script&lang=js"
import style0 from "./el-table2.vue?vue&type=style&index=0&id=639d0f10&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "639d0f10",
  null
  
)

export default component.exports